import { createContext, useContext } from 'react'
import type User from '@/types/UserType'

type AuthState = {
  user: User | null
  isAuthenticated: boolean
  isAuthChecking: boolean
}
export const AuthContext = createContext<AuthState | null>(null)

export function useAuth() {
  const context = useContext(AuthContext)
  if (!context) throw new Error('useAuth requires AuthProvider')
  return context
}
